import React, { useEffect, useState } from "react"
import moment from "moment"
import { Box, List, ListItem, ListItemText, makeStyles, ListItemSecondaryAction, IconButton, useTheme } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import _ from "lodash"
import { deleteSavedDateRange, getSavedDateRange } from "../../actions/createTimelineActions"
import DeleteUserSVG from "../icons/DeleteUserSVG"
import ConfirmationDialog from "../common/dialog/ConfirmationDialog"

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
	},
	noData: {
		display: "flex",
		justifyContent: "center",
	},
	listWrapper: {
		height: 525,
	},
}))

const SavedSearchDateRange = (props) => {
	const classes = useStyles()
	const { dateRangeHandler, handleDateRangeChange, refetchList, setSelectedGraphDateRange, initilaselectedDateRange } = props
	const theme = useTheme()
	const [t] = useTranslation("global")
	const dispatch = useDispatch()
	const data = useSelector((state) => state.timeline.savedDateRange)
	const authentication = useSelector((state) => state.authtentication)
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
	const [selectedTimeRange, setSelectedTimeRange] = useState({})

	useEffect(() => {
		dispatch(getSavedDateRange())
	}, [])

	const onConfirm = () => {
		dispatch(deleteSavedDateRange(selectedTimeRange?.id))
		setOpenDeleteDialog(false)
		setSelectedTimeRange({})
	}

	const onDismiss = () => {
		setOpenDeleteDialog(false)
		setSelectedTimeRange({})
	}

	return (
		<>
			<Box>
				<List dense={true} style={{ padding: 0, margin: 0 }}>
					{!_.isEmpty(data) ? (
						<List dense={true} className={classes.listWrapper} style={{ padding: 0, margin: 0, overflowY: "auto" }}>
							{data?.map((data) => {
								const dateRange = `${moment.utc(data?.start_date).local().format("LL")} - ${moment(
									moment.utc(data?.end_date)
								).format("LL")}`
								return (
									<ListItem style={{ background: theme.palette.text.white, borderRadius: "5px" }}>
										<ListItemText
											onClick={(e) => {
												if (e?.target.className.includes("MuiListItemText-primary")) {
													setSelectedGraphDateRange(initilaselectedDateRange)
													dateRangeHandler({
														startDate: data?.start_date ? moment(data?.start_date) : "",
														endDate: data?.end_date ? moment(data?.end_date) : "",
													})
													handleDateRangeChange({
														startDate: data?.start_date ? moment(data?.start_date) : "",
														endDate: data?.end_date ? moment(data?.end_date) : "",
													})
												}
											}}
											primary={data?.name}
											primaryTypographyProps={{
												style: {
													...theme.typography.body1,
													color: theme.palette.text.selected,
													cursor: "pointer",
												},
											}}
											secondaryTypographyProps={{
												style: { ...theme.typography.body2, color: theme.palette.text.primary },
											}}
											secondary={dateRange}
										/>
										{data?.userid === authentication.user.token.userid && (
											<ListItemSecondaryAction>
												<IconButton
													edge="end"
													aria-label="delete"
													style={{
														cursor: "pointer",
													}}
												>
													<Box
														onClick={() => {
															setSelectedTimeRange(data)
															setOpenDeleteDialog(true)
														}}
														style={{
															cursor: "pointer",
														}}
													>
														<DeleteUserSVG />
													</Box>
												</IconButton>
											</ListItemSecondaryAction>
										)}
									</ListItem>
								)
							})}
						</List>
					) : (
						<ListItemText
							primaryTypographyProps={{
								style: { ...theme.typography.body1, padding: "20px" },
							}}
							className={classes.listWrapper}
							primary={t("timeline.noSavedDateRanges")}
						/>
					)}
				</List>
			</Box>
			<ConfirmationDialog
				open={openDeleteDialog}
				title={t("timeline.deleteDateRange")}
				message={t("timeline.deleteDateRangeDesc", { name: selectedTimeRange?.name })}
				onConfirm={onConfirm}
				onDismiss={onDismiss}
				btnText={t("confirmationDialog.comment.delete")}
			/>
		</>
	)
}

export default SavedSearchDateRange
